import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
const LOGO_SRC = "/assets/feeding-blue-logo.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-slate-100 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="eyebrow text-blue-500 mb-4">Feeding Blue • Columbus, OH</div>
            <h3 className="font-display text-4xl sm:text-6xl md:text-7xl font-black leading-none tracking-tighter">
              We feed the body.<br />
              <span className="text-blue-500">We steady the family.</span>
            </h3>
            <p className="mt-8 text-slate-400 max-w-xl leading-relaxed">
              A nonprofit organization standing with law enforcement officers and their families in
              seasons of grief, trauma, and crisis — with meals, care, and presence.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-slate-500 mb-4">Explore</div>
            <ul className="space-y-3">
              <li><a href="#about" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-about">About</a></li>
              <li><a href="#what-we-do" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-what">What We Do</a></li>
              <li><a href="#how" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-how">How It Works</a></li>
              <li><a href="#agencies" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-agencies">For Agencies</a></li>
              <li><a href="#events" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-events">Events</a></li>
              <li><a href="#leadership" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-leadership">Leadership</a></li>
              <li><a href="#join-team" className="text-sm hover:text-blue-400 transition-colors font-semibold" data-testid="footer-link-hiring">Hiring · Volunteer</a></li>
              <li><Link to="/donate" className="text-sm hover:text-blue-400 transition-colors" data-testid="footer-link-donate">Donate</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-slate-500 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-slate-300">
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> <a href="mailto:info@feedingblue.org" className="hover:text-blue-400 transition-colors" data-testid="footer-email-info">info@feedingblue.org</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> <a href="mailto:support@feedingblue.org" className="hover:text-blue-400 transition-colors" data-testid="footer-email-support">support@feedingblue.org</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> <a href="mailto:events@feedingblue.org" className="hover:text-blue-400 transition-colors" data-testid="footer-email-events">events@feedingblue.org</a></li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> <a href="mailto:partnerships@feedingblue.org" className="hover:text-blue-400 transition-colors" data-testid="footer-email-partnerships">partnerships@feedingblue.org</a></li>
              <li className="flex items-start gap-3 pt-2"><Phone className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> (614) XXX-XXXX</li>
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-blue-500 shrink-0" /> Columbus, Ohio</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-3 font-display font-black tracking-tight">
            <img src={LOGO_SRC} alt="Feeding Blue logo" className="h-9 w-auto object-contain" />
            FEEDING BLUE
          </div>
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} Feeding Blue. Nonprofit organization supporting Ohio law enforcement families.
          </div>
        </div>
      </div>
    </footer>
  );
}
